import { Component, OnInit } from '@angular/core';
import PlatformJson from './platform.json';
import CliJson from './cli.json';

@Component({
  selector: 'app-sbom',
  templateUrl: './sbom.component.html',
  styleUrls: ['./sbom.component.css']
})
export class SbomComponent implements OnInit {
  //declare variables
  strTitle: string = "";
  strType: string = "";
  sbom: any[] = [];
  strUrl: string = "";

  //inject services
  constructor() { }

  //initialize variables
  ngOnInit(): void {
    if (PlatformJson["components"].length > 0) {
      PlatformJson["components"].forEach((item: any) => {
        this.sbom.push(item);
      });
    }
    if (CliJson["components"].length > 0) {
      CliJson["components"].forEach((item: any) => {
        this.sbom.push(item);
      });
    }
    this.sbom.forEach(item => {
      if (item["licenses"] != null) {
        item["license"] = item["licenses"][0].license.id;
      }
    });
  }

}
